import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllCountries,
  onCreateCountry,
  onDeleteCountry,
  onGetCountry,
  onUpdateCountry,
} from '../../../app/modules/base-definitions/components/countries/core/_requests'
interface CountryState {
  countries: any
  country: any
  isLoading: boolean
}
const initialState = {
  countries: [],
  country: null,
  isLoading: true,
} as CountryState

export const fetchCountries = createAsyncThunk('country/fetchCountries', async (param: any) => {
  const data: any = await onGetPagedAllCountries(param)
  return data.data.result
})

export const fetchCountry = createAsyncThunk('country/fetchCountry', async (param: any) => {
  const data: any = await onGetCountry(param)
  return data.data.result
})

export const updateCountry = createAsyncThunk('country/updateCountry', async (param: any) => {
  const data: any = await onUpdateCountry(param)
  return data.data
})

export const createCountry = createAsyncThunk('country/createCountry', async (param: any) => {
  const data: any = await onCreateCountry(param)
  return data.data
})

export const deleteCountry = createAsyncThunk('country/deleteCountry', async (param: any) => {
  const data: any = await onDeleteCountry(param)
  return data.data
})

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    clearCountries: (state) => {
      state.countries = []
    },
    clearCountry: (state) => {
      state.country = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCountries.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchCountries.fulfilled, (state: any, action) => {
      state.countries = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchCountries.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchCountry.fulfilled, (state: any, action) => {
      state.country = action.payload
    })
  },
})

export const {clearCountries, clearCountry, activateLoading} = countrySlice.actions

export default countrySlice.reducer
